import { render, staticRenderFns } from "./customButton.vue?vue&type=template&id=65b39900&scoped=true&"
import script from "./customButton.vue?vue&type=script&lang=js&"
export * from "./customButton.vue?vue&type=script&lang=js&"
import style0 from "./customButton.vue?vue&type=style&index=0&id=65b39900&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b39900",
  null
  
)

export default component.exports